import hres3cuLabels from 'assets/labels/hres3cu'
import faker from 'faker'
import moment from 'moment'
import labels from 'src/../config/label.js'

export const mocker = {
  labels () {
    return {
      labels: hres3cuLabels
    }
  },
  index () {
    let mockRows = []
    let staappr = ''
    const mockStaappr = [ 'N', 'D', 'S', 'C' ]
    const mockStatus = {
      'N': 'คำร้องใหม่',
      'D': 'ระหว่างดำเนินการ',
      'S': 'จบ',
      'C': 'ยกเลิก'
    }
    const mockTotal = 5
    for (var i = 1; i <= mockTotal; i++) {
      staappr = mockStaappr[Math.floor(Math.random() * 4)]
      mockRows.push({
        id: i,
        numcom: faker.random.number(),
        dtecompl: moment().format('DD/MM/YYYY'),
        codempid: faker.lorem.word(),
        desc_codempid: faker.name.findName(),
        desc_codcomp: faker.company.companyName(),
        desc_typcomp: faker.lorem.word(),
        staappr: '',
        status: mockStatus[staappr],
        stacompl: mockStatus[staappr],
        codcomp: faker.lorem.word(),
        typcomp: faker.lorem.word()
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  detail () {
    return {
      codempid: faker.lorem.word(),
      desc_codempid: faker.name.findName(),
      numcom: faker.random.number(),
      dtecompl: moment().format('DD/MM/YYYY'),
      typcompl: faker.lorem.word(),
      desc_typcompl: faker.lorem.word(),
      descompl: faker.random.words(),
      stacompl: '',
      codappv: faker.lorem.word(),
      desc_codappv: faker.name.findName(),
      path_filenam1: faker.internet.url(),
      path_filenam2: faker.internet.url(),
      path_filenam3: faker.internet.url(),
      filenam1: faker.random.uuid(),
      filenam2: faker.random.uuid(),
      filenam3: faker.random.uuid(),
      desnote: faker.random.words()
    }
  },
  detailProcess () {
    let mockDetailProcess = {
      numcom: faker.random.number(),
      codempid: faker.random.number(),
      desc_codempid: faker.name.findName(),
      desc_codcomp: faker.company.companyName(),
      codcomp: faker.lorem.word(),
      codappv: faker.lorem.word(),
      stacompl: faker.lorem.word()
    }
    let mockDetailPrcessRows = []
    const mockDetailPrcessTotal = 5
    for (var i = 1; i <= mockDetailPrcessTotal; i++) {
      mockDetailPrcessRows.push({
        id: i,
        dteopert: moment().format('DD/MM/YYYY'),
        codopert: faker.random.number(),
        desc_codopert: faker.lorem.word(),
        desopert: faker.lorem.word(),
        limopert: faker.lorem.word()
      })
    }

    return {
      detail: mockDetailProcess,
      table: {
        total: mockDetailPrcessTotal,
        rows: mockDetailPrcessRows
      }
    }
  },
  complaints () {
    let mockTab1 = {
      numcom: faker.random.number(),
      codempid: faker.lorem.word(),
      desc_codempid: faker.name.findName(),
      desc_codcomp: faker.company.companyName(),
      codcomp: faker.lorem.word(),
      codappv: faker.lorem.word(),
      stacompl: faker.lorem.word()
    }
    let mockTab1Rows = []
    const mockTab1Total = 5
    for (var i = 1; i <= mockTab1Total; i++) {
      mockTab1Rows.push({
        id: i,
        dteopert: moment().format('DD/MM/YYYY'),
        codopert: faker.lorem.word(),
        desc_codopert: faker.name.findName(),
        desopert: faker.random.word(),
        limopert: faker.random.word()
      })
    }
    let mockTab2 = {
      numcom: faker.random.number(),
      dteopert: moment().format('DD/MM/YYYY'),
      codopert: faker.lorem.word(),
      desopert: faker.random.word(),
      limopert: faker.random.word(),
      resopert: faker.random.word(),
      dteres: moment().format('DD/MM/YYYY'),
      dteclose: faker.random.word()
    }

    return {
      tab1: {
        detail: mockTab1,
        table: {
          total: mockTab1Total,
          rows: mockTab1Rows
        }
      },
      tab2: mockTab2
    }
  },
  detailPopupProcessCreate () {
    return {
      numcom: faker.random.number(),
      dteopert: '',
      codopert: '',
      desopert: '',
      resopert: '',
      dteres: '',
      dteclose: '',
      staappr: ''
    }
  },
  detailPopupProcess () {
    return {
      numcom: faker.random.number(),
      dteopert: moment().format('DD/MM/YYYY'),
      codopert: faker.lorem.word(),
      limopert: faker.lorem.word(),
      desopert: faker.lorem.words(),
      resopert: faker.lorem.words(),
      dteres: moment().format('DD/MM/YYYY'),
      dteclose: moment().format('DD/MM/YYYY')
    }
  },
  delete () {
    return labels.mockPostMessage
  },
  save () {
    return labels.mockPostMessage
  }
}



// WEBPACK FOOTER //
// ./src/api/hres3cu/mocker.js